<template>
	<div class="mycomment">
		<div class="comment-head">
			<div class="comment-head-con" v-for="(item, index) in comment" :key="index">
				<div class="comment-myhead">
					<div class="comment-myhead-left">
						<p class="comment-myhead-left-p" @click="toWorks(item.mainid)">{{item.catename.bookname}}</p>
						<p class="comment-myhead-left-p1">/{{item.catename.catename}}</p>
					</div>
					<div class="comment-myhead-right">
						<p class="comment-myhead-right-p">{{item.create_time}}</p>
					</div>
				</div>
				<div>
					<p class="comment-mycon">{{item.content}}</p>
				</div>
			</div>
		</div>
		<div class="comment-foot">
			<div class="block">
				<!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
				></el-pagination>-->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			toWorks(id) {
				const InfoDetail = this.$router.resolve({
					path: "/works",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			}
		},
		data() {
			return {
				currentPage1: 5,
				currentPage2: 5,
				currentPage3: 5,
				currentPage4: 4,
				comment: ""
			};
		},

		beforeCreate() {
			this.$http
				.post("user/mycomm/", {
					token: this.$cookies.get("token"),
					page: 1,
					size: 5
				})
				.then(res => {
					if (res.body.code == 1) {
						this.comment = res.body.data.data;
					}
				});
		}
	};
</script>
<style>
	.el-pager li.active {
		color: #28a3b1;
	}
	.el-pager li:hover {
		color: #28a3b1;
	}
	.el-pagination {
		margin-top: 20px;
	}
</style>
<style  scoped="scoped">
	.comment-head {
		width: 900px;
		height: 733px;
		padding: 0 30px 30px;
		box-sizing: border-box;
		border: 1px solid #e6e6e6;
		border-radius: 6px !important;
		background-color: #fff;
	}

	.comment-foot {
		width: 900px;
		display: flex;
		justify-content: center;
		background-color: #f5f5f5;
	}
	.comment-head-con {
		width: 100%;
		padding: 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #e6e6e6;
	}
	.comment-myhead {
		display: flex;
		width: 100%;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.comment-myhead-left {
		display: flex;
		align-items: center;
	}
	.comment-myhead-left-p {
		font-size: 18px;
		color: #28a3b1;
		font-weight: bold;
		margin-right: 5px;
		cursor: pointer;
	}
	.comment-myhead-left-p1 {
		font-size: 12px;
	}
	.comment-myhead-right-p {
		font-size: 12px;
		color: #808080;
	}
	.comment-myhead-right {
		display: flex;
		align-items: center;
	}
	.comment-mycon {
		width: 100%;
		font-size: 14px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 6;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/comment.vue